module.exports = __webpack_public_path__ + "img/Violet.aeb0541e.jpg";